import React from "react";

import Rodal from "rodal";
import "rodal/lib/rodal.css";

import './UnpackerResultModal.scss';

import CardSlider from "../../components/Unpacker/CardSlider/CardSlider";

export default function UnpackerResultModal({ visible, onClose, onDoneClicked, landsEarned, cardsEarned }) {
    return (
      <Rodal
          visible={visible}
          onClose={onClose}
          showCloseButton={false}
          className="unpacker-result"
          animation="slideUp"
          duration={800}
          closeOnEsc={true}
          width={null}
          height={null}
      >
          <div className={'unpacker-result-wrapper'}>
              { landsEarned.length || cardsEarned.length
                  ? <CardSlider
                      lands={landsEarned}
                      onDoneClicked={() => onDoneClicked()}
                  />
                  : <p />
              }
          </div>
      </Rodal>
    );
}
